<template>
	<div class="row works-content">
		<div class="col-full masonry-wrap">
			<div class="masonry">
				<template v-for="screenshot in gallery">
					<div class="masonry__brick" data-aos="fade-up">
						<div class="item-folio">
							<div class="item-folio__thumb">
								<a v-bind="{href: screenshot[3], title: screenshot[0], 'data-size': screenshot[2]}" class="thumb-link">
									<img v-bind="{src: screenshot[4], srcset: screenshot[4] + ' 1x, ' + screenshot[5] + ' 2x', alt: $t('titles.' + screenshot[1])}">
								</a>
							</div>

							<div class="item-folio__text">
								<h3 class="item-folio__title" v-html="$t('titles.' + screenshot[0])"></h3>
								<p class="item-folio__cat" v-html="$t('titles.' + screenshot[1])"></p>
							</div>

							<!--<a href="https://www.behance.net/" class="item-folio__project-link" title="Project link">
								<i class="icon-link"></i>
							</a>-->

							<div class="item-folio__caption">
								<p v-html="$t('titles.' + screenshot[1])"></p>
							</div>
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	// import params
	import {params as SiteParams} from '../../params';

	// export
	export default {
		name: 'WidgetsGallery',
		data: function () {
			return {
				gallery: SiteParams['gallery']
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/widgets/Gallery.vue